import { localGetData } from "../utils/utils";

export const getTimestampFromLocalStorage = (name) => {
  if (!name) {
    return null;
  }
  return localGetData(name) || null;
};
